// material
// components
import InspectionEventLogsList from './list';
// ----------------------------------------------------------------------
export default function InspectionEventLogs(props) {
    return <InspectionEventLogsList inspectionId={props.inspectionId} inspectionAssignmentId={props.inspectionAssignmentId}  />
}
